import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ApiClient } from "../../utils/api-client";
import Loading from "./Loading";
import { AxiosError } from "axios";
const Login = ( props ) => {
  const [ isLoading, setIsLoading ] = useState( false );
  const [ feedback, setFeeback ] = useState( "" );
  const [ showPassword, setShowPassword ] = useState( false );
  const session = window.sessionStorage;
  const navigate = useNavigate();
  const location = useLocation();
  const apiClient = new ApiClient()
  const sendLogin = async ( loginForm ) => {
    setIsLoading( true );
    let inputs = Array.from( loginForm.elements );
    let email = inputs[ 0 ].value.trim();
    let pword = inputs[ 1 ].value.trim();
    try {
      const response = await apiClient.signIn( email, pword )
      if ( response.status == 200 || response.status == 201 ) {
        const data = await response.data.data
        return { status: response.status, user: data };
      } else {
        const errorData = await response.json();
        return { status: response.status, msg: errorData.message || "Login failed" };
      }
    } catch ( e ) {
      console.log( e );
      setIsLoading( false );
      return { status: 400, msg: e instanceof AxiosError ? e.response?.data.msg : "Oops! Something went wrong." };
    }
  }
  const handleSubmit = async ( e ) => {
    e.preventDefault();
    setIsLoading( true );
    const result = await sendLogin( e.target );
    setIsLoading( false );

    if ( result.status !== 200 && result.status !== 201 ) {
      setFeeback( result.msg || "Login failed" );
    }
    else {
      setIsLoading( false );
      let user = result.user;
      session.setItem( "loginState", JSON.stringify( user ) );
      navigate( location.target ? location.target : "/dashboard", { replace: true } );
    }
  }

  return (

    <section className="h-screen w-full mx-auto p-0 flex flex-col justify-center items-center">
      <div className="flex flex-col justify-center items-center">
        <p className="text-2xl text-center py-8">Sign In</p>
      </div>
      <div className="bg-grey-700 text-primary p-8 rounded-lg shadow-lg w-10/12 md:w-5/12 py-16 mx-auto">
        {feedback?.length > 0 ? <div className="border bg-red-200 border-red-500 text-red-500 text-center p-4 mb-4 rounded" id="feedback">{feedback}</div> : null}
        <form id="loginform"
          className="md:w-6/12 mx-auto py-16"
          method="post" onSubmit={handleSubmit}
        >

          <div className="form-group mb-4">
            <input
              type="email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-transparent text-gray-700"
              id="email"
              name="email"
              required
              placeholder="E-mail"
            />
          </div>

          <div className="form-group">
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-transparent text-gray-700"
                id="password"
                name="password"
                placeholder="Password"
              />

            </div>
          </div>
          <div className="form-group py-6">
            <a className="my-6 text-secondary-500 hover:underline" href="/reset">Forgot password</a>
          </div>
          <div className="form-group">
            {isLoading ? <Loading /> :
              <input
                type="submit"
                className="w-full px-4 py-2 bg-green-800 text-white rounded-lg hover:bg-green-900 transition-colors duration-200 cursor-pointer"
                id="btnlogin"
                name="btnlogin"
                value="Sign In"
              />}
          </div>
          <div className="form-group my-2">
            <span>Not registered? &nbsp;<a className="link-button" href="/signup">Register here</a></span>
          </div>

        </form>
      </div>
    </section>
  );
}
export default Login;
